import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Promise from 'bluebird';
import { Field } from 'redux-form';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Grid from '@material-ui/core/Grid';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import update from 'immutability-helper';
import Upload from 'components/Icons/Upload';
import Close from 'components/Icons/Close';
import Progress from 'react-progressbar';
import uuidv1 from 'uuid/v1';
import ObjectID from 'bson-objectid';
import { BASE_URL } from 'consts';
import Request from 'superagent';
import { formatBytes } from 'helpers/utils';
import Empty from 'components/Empty';
import { Status, Accept } from '../modules';
import TextInput from 'components/TextInput';
import CloudDownload from '@material-ui/icons/CloudDownload';

const styles = theme => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
    padding: theme.spacing(2),
  },
  topContainer: {
    display: 'flex',
    // marginBottom: 10,
    // backgroundColor: '#ff0',
  },
  title: {
    fontSize: '1em',
    fontWeight: 'bold',
    color: '#000',
    marginBottom: 20,
  },
  centerContainer: {
    // backgroundColor: '#f00',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 10,
  },
  bottomContainer: {
    alignSelf: 'flex-end',
    // backgroundColor: '#bf0',
  },
  dropzone: {
    flexGrow: 1,
    display: 'flex',
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: '#A5D0FF',
    borderRadius: 5,
    cursor: 'pointer',
    padding: 20,
    minHeight: 100,
    justifyContent: 'center',
    alignItems: 'center',
    height: 'auto',
  },
  dropzoneText: {
    color: '#4EA2FF',
    fontSize: '0.8em',
    marginLeft: 10,
    marginBottom: 5,
  },
  subtitle: {
    fontSize: '0.9em',
    color: '#4EA2FF',
    marginBottom: 8,
    marginLeft: 10,
    fontWeight: 'bold',
  },
  fileContainer: {
    display: 'flex',
    flexDirection: 'column',
    // backgroundColor: '#ff3',
  },
  group: {
    margin: `${theme.spacing()}px 0`,
  },
  files: {
    flexDirection: 'column',
    flexWrap: 'nowrap',
    padding: 10,
    // backgroundColor: '#f03',
  },
  filesShow: {
    display: 'flex',
  },
  filesHide: {
    display: 'none',
  },
  fileContent: {
    display: 'flex',
    // backgroundColor: '#f03',
    flexGrow: 1,
  },
  fileLeft: {
    color: '#4EA2FF',
    alignSelf: 'center',
    fontSize: '0.8em',
    paddingLeft: 10,
  },
  fileRight: {
    paddingTop: 2,
    cursor: 'pointer',
    // backgroundColor: '#B7E1FF',
    minHeight: 26,
  },

  // Selected
  name: {
    fontSize: '1em',
    fontWeight: 'bold',
    color: '#000',
  },
  description: {
    fontSize: '0.8em',
    color: '#666',
    marginTop: 10,
    marginBottom: 10,
  },
  type: {
    fontSize: '1em',
    color: '#666',
  },
  filesList: {
    display: 'flex',
    flexDirection: 'column',
  },
  table: {
    width: '100%',
  },
  rowText: {
    fontSize: '0.8em',
    color: '#4EA2FF',
  },
  deleteIcon: {
    fontSize: '1.7em',
    color: '#4EA2FF',
    cursor: 'pointer',
  },
  pointer: {
    cursor: 'pointer',
  },
  statusDone: {
    color: '#00cc00',
  },
  statusPending: {
    color: '#e68a00',
  },
  statusError: {
    color: '#ff0000',
  },
});

export class Uploader extends Component {
  state = {
    // Form
    files: [],
    type: 'package',
    landingImage: [],
    // Dropzone
    accept: Accept.Package,
    message: 'Drop your .ZIP file here',
  };

  deleteFileFromQueue = key => {
    const index = this.state.files.map(el => el.key).indexOf(key);
    if (index >= 0) {
      this.setState(prevState => ({
        files: update(prevState.files, { $splice: [[index, 1]] }),
      }));
    }
  };

  deleteLadingImageFromQueue = key => {
    const index = this.state.landingImage.map(el => el.key).indexOf(key);
    if (index >= 0) {
      this.setState(prevState => ({
        landingImage: update(prevState.landingImage, { $splice: [[index, 1]] }),
      }));
    }
  };

  onDrop = accepted => {
    if (accepted.length === 0) {
      if (this.state.type === 'package') {
        this.props.handleErrorMessage('File not accepted. Only .zip files are accepted.');
      } else {
        this.props.handleErrorMessage(
          'File(s) not accepted. Only audio, video, images and html files are accepted.'
        );
      }
      return;
    }
    if (
      this.state.type === 'package' &&
      (this.state.files.length || accepted.length > 1)
    ) {
      this.props.handleErrorMessage('Only one zip file is accepted.');
      return;
    }
    accepted.forEach(f => {
      f.progress = 0;
      f.key = uuidv1();
    });
    this.setState(update(this.state, { files: { $push: accepted } }));
  };

  onDropLandingImage = accepted => {
    console.log('onDropLandingImage');
    if (accepted.length === 0) {
      this.props.handleErrorMessage('File(s) not accepted. Only images are accepted.');
      return;
    }
    if (this.state.landingImage.length || accepted.length > 1) {
      this.props.handleErrorMessage('Only one image is accepted.');
      return;
    }
    accepted.forEach(f => {
      f.progress = 0;
      f.key = uuidv1();
    });
    this.setState(update(this.state, { landingImage: { $push: accepted } }));
  };

  updateFileProgress = (fileKey, progress) => {
    const copy = this.state.files.slice();
    const index = copy.map(el => el.key).indexOf(fileKey);
    copy[index].progress = progress;
    this.setState({ files: copy });
  };

  uploadFiles = () => {
    if (!this.state.files.length || !this.state.landingImage.length) {
      this.props.handleErrorMessage('Files must me attached');
      return;
    }
    let expId = ObjectID();
    Promise.all(
      this.state.files.map(file => {
        return Request.post(`${BASE_URL}/files/uploadExperienceFile/${expId}`)
          .attach('file', file)
          .attach('landingImage', this.state.landingImage[0])
          .set('Authorization', this.props.auth.token)
          .timeout(3600000) // 1 hour
          .on('progress', event => {
            this.updateFileProgress(file.key, Math.round(event.percent || 100));
          });
      })
    )
      .then(responses => {
        // Check if all files were uploaded correctly
        if (responses.find(response => response.status !== 201)) {
          console.log('Error');
          return;
        }

        // Delete files from the dropzone
        this.state.files.forEach(file => this.deleteFileFromQueue(file.key));
        this.state.landingImage.forEach(file => this.deleteFileFromQueue(file.key));

        // Prepare form for submission
        this.props.change('campaign', this.props.match.params.id);

        this.props.change('expId', expId);
        this.props.change('fileLandingImage', responses[0].body.fileLandingImage._id);
        this.props.change('indexURL', responses[0].body.indexURL);
        this.props.change('landingImageURL', responses[0].body.landingImageURL);

        if (this.state.type === 'package') {
          this.props.change('landingPageZip', responses[0].body.fileZip._id);
        } else {
          this.props.change(
            'files',
            responses.map(response => {
              return response.body[0]._id;
            })
          );
        }

        // Submit
        this.props.handleSubmit();

        // Prepare form for new submission
        this.props.reset(); // clear all form data
        this.props.change('campaign', this.props.match.params.id); // set campaign id again
        this.setState({ files: [], landingImage: [] });
      })
      .catch(err => {
        console.log('erro upload');
        console.error(err);
      });
  };

  handleRadioChange = event => {
    const type = event.target.value;
    if (type === 'package') {
      this.setState({
        type,
        accept: Accept.Package,
        message: 'Drop your .ZIP file here',
      });
    } else {
      this.setState({
        type,
        accept: Accept.Assets,
        message: 'Drop your files here',
      });
    }
  };

  renderEmpty = () => (
    <Empty message="No experiences are currently selected" minHeight={300} />
  );

  renderAdding = () => {
    const { classes, handleSubmit, pristine, submitting, match } = this.props;

    const { files } = this.state;
    const { landingImage } = this.state;

    return (
      <form
        onSubmit={handleSubmit}
        className={classes.container}
        noValidate
        autoComplete="off"
      >
        <div className={classes.topContainer}>
          <div className={classes.title}>New Experience</div>
        </div>
        <div className={classes.centerContainer}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Field
                label="Name"
                name="name"
                component={TextInput}
                inputProps={{ maxLength: 100 }}
                fullWidth
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Field
                label="Text"
                name="text"
                component={TextInput}
                inputProps={{ maxLength: 200 }}
                fullWidth
                required
                multiline
                rows={2}
                rowsMax={5}
              />
            </Grid>
            <Grid item xs={12}>
              <FormControl component="fieldset" required className={classes.formControl}>
                <RadioGroup
                  name="type"
                  className={classes.group}
                  value={this.state.type}
                  onChange={this.handleRadioChange}
                >
                  <FormControlLabel value="package" control={<Radio />} label="Package" />
                  <FormControlLabel
                    value="assets"
                    control={<Radio />}
                    label="Assets"
                    disabled="true"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <Dropzone
                className={classes.dropzone}
                accept={this.state.accept}
                onDrop={this.onDrop}
              >
                <Upload color="#4EA2FF" />
                <span className={classes.dropzoneText}>{this.state.message}</span>
              </Dropzone>
              <div
                className={classnames(
                  classes.files,
                  files.length ? classes.filesShow : classes.filesHide
                )}
              >
                {this.state.files.map(file => {
                  return (
                    <div key={file.key} className={classes.fileContainer}>
                      <div className={classes.fileContent}>
                        <div className={classes.fileLeft}>
                          {`${file.name} (${formatBytes(file.size)})`}
                        </div>
                        <div
                          className={classes.fileRight}
                          onClick={() => this.deleteFileFromQueue(file.key)}
                        >
                          <Close size="small" color="#4EA2FF" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
            <Grid item xs={12}>
              <Dropzone
                className={classes.dropzone}
                accept={Accept.Image}
                onDrop={this.onDropLandingImage}
              >
                <Upload color="#4EA2FF" />
                <span className={classes.dropzoneText}>Drop the Landing image</span>
              </Dropzone>
              <div
                className={classnames(
                  classes.files,
                  landingImage.length ? classes.filesShow : classes.filesHide
                )}
              >
                {this.state.landingImage.map(file => {
                  return (
                    <div key={file.key} className={classes.fileContainer}>
                      <div className={classes.fileContent}>
                        <div className={classes.fileLeft}>
                          {`${file.name} (${formatBytes(file.size)})`}
                        </div>
                        <div
                          className={classes.fileRight}
                          onClick={() => this.deleteLadingImageFromQueue(file.key)}
                        >
                          <Close size="small" color="#4EA2FF" />
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </Grid>
          </Grid>
        </div>
        {this.state.files.map(file => {
          return (
            <div key={file.key} className={classes.fileContainer}>
              <div className={classes.progressBar}>
                <Progress completed={file.progress} height={2} color="#4EA2FF" />
              </div>
            </div>
          );
        })}
        <div className={classes.bottomContainer}>
          <Button
            variant="text"
            color="default"
            className={classes.button}
            onClick={() => {
              this.props.cancel();
              this.props.reset(); // clear all form data
              this.props.change('campaign', match.params.id); // set campaign id
              this.setState({ files: [], landingImage: [] });
            }}
          >
            cancel
          </Button>
          <Button
            // type="submit"
            variant="text"
            color="primary"
            className={classes.button}
            disabled={pristine || submitting}
            onClick={() => this.uploadFiles()}
          >
            create
          </Button>
        </div>
      </form>
    );
  };

  renderEditing = () => {
    return <div>Rodrigo</div>;
  };

  renderPackageRow = (classes, selected, downloadFile, progress) => {
    return (
      <React.Fragment>
        <div className={classes.progressBar}>
          {progress > 0 && <Progress completed={progress} height={2} color="#4EA2FF" />}
        </div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Files</TableCell>
              <TableCell numeric>Size</TableCell>
              {/* <TableCell>Status</TableCell>
              <TableCell numeric>Options</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow key={selected.landingPageZip._id} hover>
              <TableCell component="th" scope="row">
                {selected.landingPageZip.fileName}
              </TableCell>
              <TableCell numeric>{formatBytes(selected.landingPageZip.size)}</TableCell>
              {/* <TableCell>
                {selected.status.toUpperCase() === 'DONE' && (
                  <span className={classes.statusDone}>
                    {capitalize(selected.status)}
                  </span>
                )}
                {selected.status.toUpperCase() === 'PENDING' && (
                  <span className={classes.statusPending}>
                    {capitalize(selected.status)}
                  </span>
                )}
                {selected.status.toUpperCase() === 'ERROR' && (
                  <span className={classes.statusError}>
                    {capitalize(selected.status)}
                  </span>
                )}
              </TableCell> */}
              {/* <TableCell numeric>
                <CloudDownload
                  color="primary"
                  className={classes.pointer}
                  onClick={() => {
                    downloadFile(
                      selected.package._id,
                      selected.package.metadata.originalname,
                      selected.package.contentLength
                    );
                  }}
                />
              </TableCell> */}
            </TableRow>
            <TableRow key={selected.landingImage._id} hover>
              <TableCell component="th" scope="row">
                {selected.landingImage.fileName}
              </TableCell>
              <TableCell numeric>{formatBytes(selected.landingImage.size)}</TableCell>
              {/* <TableCell>
                {selected.status.toUpperCase() === 'DONE' && (
                  <span className={classes.statusDone}>
                    {capitalize(selected.status)}
                  </span>
                )}
                {selected.status.toUpperCase() === 'PENDING' && (
                  <span className={classes.statusPending}>
                    {capitalize(selected.status)}
                  </span>
                )}
                {selected.status.toUpperCase() === 'ERROR' && (
                  <span className={classes.statusError}>
                    {capitalize(selected.status)}
                  </span>
                )}
              </TableCell> */}
              {/* <TableCell numeric>
                <CloudDownload
                  color="primary"
                  className={classes.pointer}
                  onClick={() => {
                    downloadFile(
                      selected.package._id,
                      selected.package.metadata.originalname,
                      selected.package.contentLength
                    );
                  }}
                />
              </TableCell> */}
            </TableRow>
          </TableBody>
        </Table>
      </React.Fragment>
    );
  };

  renderFilesRows = (classes, selected, downloadFile, progress) => {
    return (
      <React.Fragment>
        <div className={classes.progressBar}>
          {progress > 0 && <Progress completed={progress} height={2} color="#4EA2FF" />}
        </div>
        <Table className={classes.table}>
          <TableHead>
            <TableRow>
              <TableCell>Assets</TableCell>
              <TableCell numeric>Size</TableCell>
              <TableCell numeric>Options</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {selected.files.map(file => (
              <TableRow key={file._id} hover>
                <TableCell component="th" scope="row">
                  {file.metadata.originalname}
                </TableCell>
                <TableCell numeric>{formatBytes(file.contentLength)}</TableCell>
                <TableCell numeric>
                  <CloudDownload
                    color="primary"
                    className={classes.pointer}
                    onClick={() => {
                      downloadFile(
                        file._id,
                        file.metadata.originalname,
                        file.contentLength
                      );
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </React.Fragment>
    );
  };

  renderSelected = () => {
    const { classes, selected, downloadFile, progress } = this.props;

    return (
      <div className={classes.container}>
        <div className={classes.topContainer}>
          <div className={classes.name}>{selected.name}</div>
        </div>
        <div className={classes.centerContainer}>
          <div className={classes.text}>{selected.text}</div>
          <div className={classes.filesList}>
            {/* {!selected.landingPageZip &&
              this.renderFilesRows(classes, selected, downloadFile, progress)} */}
            {selected.landingPageZip &&
              this.renderPackageRow(classes, selected, downloadFile, progress)}
          </div>
        </div>
      </div>
    );
  };

  render() {
    switch (this.props.mam.status) {
      case Status.EMPTY:
        return this.renderEmpty();
      case Status.ADDING:
        return this.renderAdding();
      case Status.EDITING:
        return this.renderEditing();
      default:
        return this.renderSelected();
    }
  }
}

Uploader.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  mam: PropTypes.object.isRequired,
  selected: PropTypes.object,
  handleErrorMessage: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  downloadFile: PropTypes.func.isRequired,
  progress: PropTypes.number.isRequired,
};

export default withStyles(styles)(Uploader);
